module.exports = __webpack_public_path__ + "img/service-6.b7449556.svg";